/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportUpdateConnectionMutationRequest, SocialExportUpdateConnectionMutationResponse, SocialExportUpdateConnectionPathParams, SocialExportUpdateConnection400, SocialExportUpdateConnection401, SocialExportUpdateConnection403, SocialExportUpdateConnection404 } from "../models/SocialExportUpdateConnection";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { socialExportUpdateConnection } from "../axios/socialExportUpdateConnection";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const socialExportUpdateConnectionMutationKey = () => [{ url: '/social-export/v1/connections/:id' }] as const

export type SocialExportUpdateConnectionMutationKey = ReturnType<typeof socialExportUpdateConnectionMutationKey>

export function socialExportUpdateConnectionMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SocialExportUpdateConnectionMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = socialExportUpdateConnectionMutationKey()
        return mutationOptions<SocialExportUpdateConnectionMutationResponse, ResponseErrorConfig<SocialExportUpdateConnection400 | SocialExportUpdateConnection401 | SocialExportUpdateConnection403 | SocialExportUpdateConnection404>, {id: SocialExportUpdateConnectionPathParams["id"], data: SocialExportUpdateConnectionMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return socialExportUpdateConnection(id, data, config)
          },
        })

}

/**
 * @description Updates optional custom name, station assignments, and/or platform-specific settings for a connection owned by the authenticated client. Omitted fields are left unchanged. When stationIds is present, it replaces all station assignments; an empty array clears them.
 * @summary Update a connection by id
 * {@link /social-export/v1/connections/:id}
 */
export function useSocialExportUpdateConnection<TContext>(options: 
{
  mutation?: UseMutationOptions<SocialExportUpdateConnectionMutationResponse, ResponseErrorConfig<SocialExportUpdateConnection400 | SocialExportUpdateConnection401 | SocialExportUpdateConnection403 | SocialExportUpdateConnection404>, {id: SocialExportUpdateConnectionPathParams["id"], data: SocialExportUpdateConnectionMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SocialExportUpdateConnectionMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? socialExportUpdateConnectionMutationKey()

          const baseOptions = socialExportUpdateConnectionMutationOptions(config) as UseMutationOptions<SocialExportUpdateConnectionMutationResponse, ResponseErrorConfig<SocialExportUpdateConnection400 | SocialExportUpdateConnection401 | SocialExportUpdateConnection403 | SocialExportUpdateConnection404>, {id: SocialExportUpdateConnectionPathParams["id"], data: SocialExportUpdateConnectionMutationRequest}, TContext>
          

          return useMutation<SocialExportUpdateConnectionMutationResponse, ResponseErrorConfig<SocialExportUpdateConnection400 | SocialExportUpdateConnection401 | SocialExportUpdateConnection403 | SocialExportUpdateConnection404>, {id: SocialExportUpdateConnectionPathParams["id"], data: SocialExportUpdateConnectionMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SocialExportUpdateConnectionMutationResponse, ResponseErrorConfig<SocialExportUpdateConnection400 | SocialExportUpdateConnection401 | SocialExportUpdateConnection403 | SocialExportUpdateConnection404>, {id: SocialExportUpdateConnectionPathParams["id"], data: SocialExportUpdateConnectionMutationRequest}, TContext>
      
}